export const CONSUMER = "Consumer";
export const SUPER_ADMIN = "SuperAdmin";

// Power Application Roles
export const POWER_DEPARTMENT_HEAD = "PowerDepartmentHeads";
export const POWER_CONSUMER_APPLICATION_INCHARGE =
  "PowerConsumerApplicationIncharge";
export const POWER_CONSUMER_BILLING_INCHARGE = "PowerConsumerBillingIncharge";
export const POWER_CONSUMER_APPLICATION_OPERATOR =
  "PowerConsumerApplicationOperators";
export const POWER_CONSUMER_BILLING_OPERATOR = "PowerConsumerBillingOperators";
export const POWER_FINANCE = "PowerFinance";
export const POWER_I_AND_C_TEAM = "PowerI&CTeam";
export const POWER_MANAGEMENT = "PowerManagement";
export const POWER_PREPARED_BY_ENGINEERING_DEPT =
  "PowerPreparedByEngineeringDept";
export const POWER_APPROVED_BY_ENGINEERING_DEPT =
  "PowerApprovedByEngineeringDept";
export const POWER_APPROVED_BY_ACCOUNTS_DEPT = "PowerApprovedByAccountsDept";
export const POWER_APPROVED_BY_DIRECTOR_AND_GROUP_CEO =
  "PowerApprovedByDirectorAndGroupCEO";
export const POWER_BANKING_FINANCE = "PowerBankingFinance";
export const POWER_BACKUP_POWER_BILLING_FINANCE =
  "PowerBackupPowerBillingFinance";
export const POWER_READ_ADMIN = "PowerReadAdmin";
export const POWER_CGRF_ADMIN = "PowerCGRFAdmin";

export const powerAdmin4Roles = [
  POWER_CONSUMER_APPLICATION_OPERATOR,
  POWER_CONSUMER_BILLING_OPERATOR,
];
export const powerAdmin3Roles = [
  POWER_CONSUMER_APPLICATION_INCHARGE,
  POWER_CONSUMER_BILLING_INCHARGE,
];

export const powerAdmin2Roles = [POWER_FINANCE];
export const powerAdmin1Roles = [POWER_DEPARTMENT_HEAD];

export const powerPreparedByEngineeringDeptRole = [
  POWER_PREPARED_BY_ENGINEERING_DEPT,
];
export const powerApprovedByEngineeringDeptRole = [
  POWER_APPROVED_BY_ENGINEERING_DEPT,
];
export const powerApprovedByAccountsDeptRole = [
  POWER_APPROVED_BY_ACCOUNTS_DEPT,
];
export const powerApprovedByDirectorAndGroupCEORole = [
  POWER_APPROVED_BY_DIRECTOR_AND_GROUP_CEO,
];

export const powerEngineeringRoles = [
  POWER_PREPARED_BY_ENGINEERING_DEPT,
  POWER_APPROVED_BY_ENGINEERING_DEPT,
];
export const powerIAndCTeamRole = [POWER_I_AND_C_TEAM];
export const powerManagement = [POWER_MANAGEMENT];

export const powerApplicationsRoles = [
  SUPER_ADMIN,
  POWER_DEPARTMENT_HEAD,
  POWER_CONSUMER_APPLICATION_INCHARGE,
  POWER_CONSUMER_APPLICATION_OPERATOR,
  POWER_CONSUMER_BILLING_INCHARGE,
  POWER_CONSUMER_BILLING_OPERATOR,
  POWER_I_AND_C_TEAM,
  POWER_FINANCE,
  POWER_MANAGEMENT,
  POWER_PREPARED_BY_ENGINEERING_DEPT,
  POWER_APPROVED_BY_ENGINEERING_DEPT,
  POWER_APPROVED_BY_ACCOUNTS_DEPT,
  POWER_APPROVED_BY_DIRECTOR_AND_GROUP_CEO,
  POWER_BACKUP_POWER_BILLING_FINANCE,
  POWER_BANKING_FINANCE,
  POWER_READ_ADMIN,
];

// DCS Application Roles

export const DCS_DEPARTMENT_HEAD = "DCSDepartmentHeads";
export const DCS_CONSUMER_APPLICATION_INCHARGE =
  "DCSConsumerApplicationIncharge";
export const DCS_CONSUMER_BILLING_INCHARGE = "DCSConsumerBillingIncharge";
export const DCS_CONSUMER_APPLICATION_OPERATOR =
  "DCSConsumerApplicationOperators";
export const DCS_CONSUMER_BILLING_OPERATOR = "DCSConsumerBillingOperators";
export const DCS_FINANCE = "DCSFinance";
export const DCS_I_AND_C_TEAM = "DCSI&CTeam";
export const DCS_MANAGEMENT = "DCSManagement";
export const DCS_PREPARED_BY_ENGINEERING_DEPT = "DCSPreparedByEngineeringDept";
export const DCS_APPROVED_BY_ENGINEERING_DEPT = "DCSApprovedByEngineeringDept";
export const DCS_APPROVED_BY_ACCOUNTS_DEPT = "DCSApprovedByAccountsDept";
export const DCS_APPROVED_BY_DIRECTOR_AND_GROUP_CEO =
  "DCSsApprovedByDirectorAndGroupCEO";
export const DCS_BANKING_FINANCE = "DCSBankingFinance";

export const dcsApplicationsRoles = [
  SUPER_ADMIN,
  DCS_DEPARTMENT_HEAD,
  DCS_CONSUMER_APPLICATION_INCHARGE,
  DCS_CONSUMER_APPLICATION_OPERATOR,
  DCS_CONSUMER_BILLING_INCHARGE,
  DCS_CONSUMER_BILLING_OPERATOR,
  DCS_I_AND_C_TEAM,
  DCS_FINANCE,
  DCS_MANAGEMENT,
  DCS_PREPARED_BY_ENGINEERING_DEPT,
  DCS_APPROVED_BY_ENGINEERING_DEPT,
  DCS_APPROVED_BY_ACCOUNTS_DEPT,
  DCS_APPROVED_BY_DIRECTOR_AND_GROUP_CEO,
  DCS_BANKING_FINANCE,
];

export const dcsAdmin4Roles = [
  DCS_CONSUMER_APPLICATION_OPERATOR,
  DCS_CONSUMER_BILLING_OPERATOR,
];
export const dcsAdmin3Roles = [
  DCS_CONSUMER_APPLICATION_INCHARGE,
  DCS_CONSUMER_BILLING_INCHARGE,
];

export const dcsAdmin2Roles = [DCS_FINANCE];
export const dcsAdmin1Roles = [DCS_DEPARTMENT_HEAD];

export const dcsPreparedByEngineeringDeptRole = [
  DCS_PREPARED_BY_ENGINEERING_DEPT,
];
export const dcsApprovedByEngineeringDeptRole = [
  DCS_APPROVED_BY_ENGINEERING_DEPT,
];
export const dcsApprovedByAccountsDeptRole = [DCS_APPROVED_BY_ACCOUNTS_DEPT];
export const dcsApprovedByDirectorAndGroupCEORole = [
  DCS_APPROVED_BY_DIRECTOR_AND_GROUP_CEO,
];

export const dcsEngineeringRoles = [
  DCS_PREPARED_BY_ENGINEERING_DEPT,
  DCS_APPROVED_BY_ENGINEERING_DEPT,
];
export const dcsIAndCTeamRole = [DCS_I_AND_C_TEAM];
export const dcsManagement = [DCS_MANAGEMENT];

// Water Application Roles

export const WATER_DEPARTMENT_HEAD = "WaterDepartmentHeads";
export const WATER_CONSUMER_APPLICATION_INCHARGE =
  "WaterConsumerApplicationIncharge";
export const WATER_CONSUMER_BILLING_INCHARGE = "WaterConsumerBillingIncharge";
export const WATER_CONSUMER_APPLICATION_OPERATOR =
  "WaterConsumerApplicationOperators";
export const WATER_CONSUMER_BILLING_OPERATOR = "WaterConsumerBillingOperators";
export const WATER_FINANCE = "WaterFinance";
export const WATER_I_AND_C_TEAM = "WaterI&CTeam";
export const WATER_MANAGEMENT = "WaterManagement";
export const WATER_PREPARED_BY_ENGINEERING_DEPT =
  "WaterPreparedByEngineeringDept";
export const WATER_APPROVED_BY_ENGINEERING_DEPT =
  "WaterApprovedByEngineeringDept";
export const WATER_APPROVED_BY_ACCOUNTS_DEPT = "WaterApprovedByAccountsDept";
export const WATER_APPROVED_BY_DIRECTOR_AND_GROUP_CEO =
  "WaterApprovedByDirectorAndGroupCEO";
export const WATER_BANKING_FINANCE = "WaterBankingFinance";

export const waterApplicationsRoles = [
  SUPER_ADMIN,
  WATER_DEPARTMENT_HEAD,
  WATER_CONSUMER_APPLICATION_INCHARGE,
  WATER_CONSUMER_APPLICATION_OPERATOR,
  WATER_CONSUMER_BILLING_INCHARGE,
  WATER_CONSUMER_BILLING_OPERATOR,
  WATER_I_AND_C_TEAM,
  WATER_FINANCE,
  WATER_MANAGEMENT,
  WATER_PREPARED_BY_ENGINEERING_DEPT,
  WATER_APPROVED_BY_ENGINEERING_DEPT,
  WATER_APPROVED_BY_ACCOUNTS_DEPT,
  WATER_APPROVED_BY_DIRECTOR_AND_GROUP_CEO,
  WATER_BANKING_FINANCE,
];

// Sewage Application Roles

export const SEWAGE_DEPARTMENT_HEAD = "SewageDepartmentHeads";
export const SEWAGE_CONSUMER_APPLICATION_INCHARGE =
  "SewageConsumerApplicationIncharge";
export const SEWAGE_CONSUMER_BILLING_INCHARGE = "SewageConsumerBillingIncharge";
export const SEWAGE_CONSUMER_APPLICATION_OPERATOR =
  "SewageConsumerApplicationOperators";
export const SEWAGE_CONSUMER_BILLING_OPERATOR =
  "SewageConsumerBillingOperators";
export const SEWAGE_FINANCE = "SewageFinance";
export const SEWAGE_I_AND_C_TEAM = "SewageI&CTeam";
export const SEWAGE_MANAGEMENT = "SewageManagement";
export const SEWAGE_PREPARED_BY_ENGINEERING_DEPT =
  "SewagePreparedByEngineeringDept";
export const SEWAGE_APPROVED_BY_ENGINEERING_DEPT =
  "SewageApprovedByEngineeringDept";
export const SEWAGE_APPROVED_BY_ACCOUNTS_DEPT = "SewageApprovedByAccountsDept";
export const SEWAGE_APPROVED_BY_DIRECTOR_AND_GROUP_CEO =
  "SewageApprovedByDirectorAndGroupCEO";
export const SEWAGE_BANKING_FINANCE = "SewageBankingFinance";

export const sewageApplicationsRoles = [
  SUPER_ADMIN,
  SEWAGE_DEPARTMENT_HEAD,
  SEWAGE_CONSUMER_APPLICATION_INCHARGE,
  SEWAGE_CONSUMER_APPLICATION_OPERATOR,
  SEWAGE_CONSUMER_BILLING_INCHARGE,
  SEWAGE_CONSUMER_BILLING_OPERATOR,
  SEWAGE_I_AND_C_TEAM,
  SEWAGE_FINANCE,
  SEWAGE_MANAGEMENT,
  SEWAGE_PREPARED_BY_ENGINEERING_DEPT,
  SEWAGE_APPROVED_BY_ENGINEERING_DEPT,
  SEWAGE_APPROVED_BY_ACCOUNTS_DEPT,
  SEWAGE_APPROVED_BY_DIRECTOR_AND_GROUP_CEO,
  SEWAGE_BANKING_FINANCE,
];

// Solid Was Application Roles

export const SOLID_WASTE_DEPARTMENT_HEAD = "SolidWasteDepartmentHeads";
export const SOLID_WASTE_CONSUMER_APPLICATION_INCHARGE =
  "SolidWasteConsumerApplicationIncharge";
export const SOLID_WASTE_CONSUMER_BILLING_INCHARGE =
  "SolidWasteConsumerBillingIncharge";
export const SOLID_WASTE_CONSUMER_APPLICATION_OPERATOR =
  "SolidWasteConsumerApplicationOperators";
export const SOLID_WASTE_CONSUMER_BILLING_OPERATOR =
  "SolidWasteConsumerBillingOperators";
export const SOLID_WASTE_FINANCE = "SolidWasteFinance";
export const SOLID_WASTE_I_AND_C_TEAM = "SolidWasteI&CTeam";
export const SOLID_WASTE_MANAGEMENT = "SolidWasteManagement";
export const SOLID_WASTE_PREPARED_BY_ENGINEERING_DEPT =
  "SolidWastePreparedByEngineeringDept";
export const SOLID_WASTE_APPROVED_BY_ENGINEERING_DEPT =
  "SolidWasteApprovedByEngineeringDept";
export const SOLID_WASTE_APPROVED_BY_ACCOUNTS_DEPT =
  "SolidWasteApprovedByAccountsDept";
export const SOLID_WASTE_APPROVED_BY_DIRECTOR_AND_GROUP_CEO =
  "SolidWasteApprovedByDirectorAndGroupCEO";
export const SOLID_WASTE_BANKING_FINANCE = "SolidWasteBankingFinance";

export const solidWasteApplicationsRoles = [
  SUPER_ADMIN,
  SOLID_WASTE_DEPARTMENT_HEAD,
  SOLID_WASTE_CONSUMER_APPLICATION_INCHARGE,
  SOLID_WASTE_CONSUMER_APPLICATION_OPERATOR,
  SOLID_WASTE_CONSUMER_BILLING_INCHARGE,
  SOLID_WASTE_CONSUMER_BILLING_OPERATOR,
  SOLID_WASTE_I_AND_C_TEAM,
  SOLID_WASTE_FINANCE,
  SOLID_WASTE_MANAGEMENT,
  SOLID_WASTE_PREPARED_BY_ENGINEERING_DEPT,
  SOLID_WASTE_APPROVED_BY_ENGINEERING_DEPT,
  SOLID_WASTE_APPROVED_BY_ACCOUNTS_DEPT,
  SOLID_WASTE_APPROVED_BY_DIRECTOR_AND_GROUP_CEO,
  SOLID_WASTE_BANKING_FINANCE,
];

export const otherUtilitiesRoles = [
  SUPER_ADMIN,
  ...solidWasteApplicationsRoles,
  ...sewageApplicationsRoles,
  ...waterApplicationsRoles,
];

export const otherUtilitiesApplicationAdmin4Roles = [
  WATER_CONSUMER_APPLICATION_OPERATOR,
  SEWAGE_CONSUMER_APPLICATION_OPERATOR,
  SOLID_WASTE_CONSUMER_APPLICATION_OPERATOR,
];

export const otherUtilitiesBillingAdmin4Roles = [
  WATER_CONSUMER_BILLING_OPERATOR,
  SEWAGE_CONSUMER_BILLING_OPERATOR,
  SOLID_WASTE_CONSUMER_BILLING_OPERATOR,
];

export const otherUtilitiesAdmin4Roles = [
  WATER_CONSUMER_APPLICATION_OPERATOR,
  WATER_CONSUMER_BILLING_OPERATOR,
  SEWAGE_CONSUMER_APPLICATION_OPERATOR,
  SEWAGE_CONSUMER_BILLING_OPERATOR,
  SOLID_WASTE_CONSUMER_APPLICATION_OPERATOR,
  SOLID_WASTE_CONSUMER_BILLING_OPERATOR,
];

export const otherUtilitiesApplicationAdmin3Roles = [
  WATER_CONSUMER_APPLICATION_INCHARGE,
  SEWAGE_CONSUMER_APPLICATION_INCHARGE,
  SOLID_WASTE_CONSUMER_APPLICATION_INCHARGE,
];

export const otherUtilitiesBillingAdmin3Roles = [
  WATER_CONSUMER_BILLING_INCHARGE,
  SEWAGE_CONSUMER_BILLING_INCHARGE,
  SOLID_WASTE_CONSUMER_BILLING_INCHARGE,
];

export const otherUtilitiesAdmin3Roles = [
  WATER_CONSUMER_APPLICATION_INCHARGE,
  WATER_CONSUMER_BILLING_INCHARGE,
  SEWAGE_CONSUMER_APPLICATION_INCHARGE,
  SEWAGE_CONSUMER_BILLING_INCHARGE,
  SOLID_WASTE_CONSUMER_APPLICATION_INCHARGE,
  SOLID_WASTE_CONSUMER_BILLING_INCHARGE,
];

export const otherUtilitiesAdmin2Roles = [
  WATER_FINANCE,
  SEWAGE_FINANCE,
  SOLID_WASTE_FINANCE,
];

export const otherUtilitiesAdmin1Roles = [
  WATER_DEPARTMENT_HEAD,
  SEWAGE_DEPARTMENT_HEAD,
  SOLID_WASTE_DEPARTMENT_HEAD,
];

export const otherUtilitiesPreparedByEngineeringDeptRole = [
  WATER_PREPARED_BY_ENGINEERING_DEPT,
  SEWAGE_PREPARED_BY_ENGINEERING_DEPT,
  SOLID_WASTE_PREPARED_BY_ENGINEERING_DEPT,
];

export const otherUtilitiesApprovedByEngineeringDeptRole = [
  WATER_APPROVED_BY_ENGINEERING_DEPT,
  SEWAGE_APPROVED_BY_ENGINEERING_DEPT,
  SOLID_WASTE_APPROVED_BY_ENGINEERING_DEPT,
];
export const otherUtilitiesApprovedByAccountsDeptRole = [
  WATER_APPROVED_BY_ACCOUNTS_DEPT,
  SEWAGE_APPROVED_BY_ACCOUNTS_DEPT,
  SOLID_WASTE_APPROVED_BY_ACCOUNTS_DEPT,
];

export const otherUtilitiesApprovedByDirectorAndGroupCEORole = [
  WATER_APPROVED_BY_DIRECTOR_AND_GROUP_CEO,
  SEWAGE_APPROVED_BY_DIRECTOR_AND_GROUP_CEO,
  SOLID_WASTE_APPROVED_BY_DIRECTOR_AND_GROUP_CEO,
];

export const otherUtilitiesEngineeringRoles = [
  WATER_PREPARED_BY_ENGINEERING_DEPT,
  WATER_APPROVED_BY_ENGINEERING_DEPT,
  SEWAGE_PREPARED_BY_ENGINEERING_DEPT,
  SEWAGE_APPROVED_BY_ENGINEERING_DEPT,
  SOLID_WASTE_PREPARED_BY_ENGINEERING_DEPT,
  SOLID_WASTE_APPROVED_BY_ENGINEERING_DEPT,
];

export const otherUtilitiesIAndCTeamRole = [
  WATER_I_AND_C_TEAM,
  SEWAGE_I_AND_C_TEAM,
  SOLID_WASTE_I_AND_C_TEAM,
];

export const otherUtilitiesManagement = [
  WATER_MANAGEMENT,
  SEWAGE_MANAGEMENT,
  SOLID_WASTE_MANAGEMENT,
];

export const allAdminRoles = [
  SUPER_ADMIN,
  ...powerApplicationsRoles,
  ...dcsApplicationsRoles,
  ...otherUtilitiesRoles,
];

export const otherUtilitiesFinanceAdminRoles = [
  DCS_FINANCE,
  WATER_FINANCE,
  SOLID_WASTE_FINANCE,
  SEWAGE_FINANCE,
  SUPER_ADMIN,
];

export const otherUtilitiesFinanceAndBillingAdminRoles = [
  ...otherUtilitiesFinanceAdminRoles,
  ...otherUtilitiesBillingAdmin4Roles,
  ...otherUtilitiesBillingAdmin3Roles,
  DCS_CONSUMER_BILLING_INCHARGE,
  DCS_CONSUMER_BILLING_OPERATOR,
];

// Fire safety roles

export const FIRE_SAFETY_CONSUMER = "FireSafetyConsumer";
export const FIRE_SAFETY_SUPER_ADMIN = "FireSafetySuperAdmin";

export const FIRE_EMERGENCY_CHIEF_FIRE_OFFICER =
  "FireAndEmergencyServicesChiefFireOfficer";
export const FIRE_AND_EMERGENCY_SERVICES_HOD = "FireAndEmergencyServicesHOD";
export const FIRE_EMERGENCY_SR_MANAGER = "FireAndEmergencyServicesSrManager";
export const FIRE_EMERGENCY_MANAGER = "FireAndEmergencyServicesManager";
export const FIRE_EMERGENCY_SR_EXECUTIVE =
  "FireAndEmergencyServicesSrExecutive";
export const FIRE_EMERGENCY_ASST_MANAGER =
  "FireAndEmergencyServicesAsstManager";

export const ICT_CHIEF_FIRE_OFFICER = "ICTChiefFireOfficer";
export const ICT_SR_MANAGER = "ICTSrManager";
export const ICT_MANAGER = "ICTManager";
export const ICT_SR_EXECUTIVE = "ICTSrExecutive";
export const ICT_ASST_MANAGER = "ICTAsstManager";

export const PLANNING_CHIEF_FIRE_OFFICER = "PlanningChiefFireOfficer";
export const PLANNING_SR_MANAGER = "PlanningSrManager";
export const PLANNING_MANAGER = "PlanningManager";
export const PLANNING_SR_EXECUTIVE = "PlanningSrExecutive";
export const PLANNING_ASST_MANAGER = "PlanningAsstManager";

export const ELECTRICAL_CHIEF_FIRE_OFFICER = "ElectricalChiefFireOfficer";
export const ELECTRICAL_SR_MANAGER = "ElectricalSrManager";
export const ELECTRICAL_MANAGER = "ElectricalManager";
export const ELECTRICAL_SR_EXECUTIVE = "ElectricalSrExecutive";
export const ELECTRICAL_ASST_MANAGER = "ElectricalAsstManager";

export const MECHANICAL_CHIEF_FIRE_OFFICER = "MechanicalChiefFireOfficer";
export const MECHANICAL_SR_MANAGER = "MechanicalSrManager";
export const MECHANICAL_MANAGER = "MechanicalManager";
export const MECHANICAL_SR_EXECUTIVE = "MechanicalSrExecutive";
export const MECHANICAL_ASST_MANAGER = "MechanicalAsstManager";

export const fireSafetyAdminRoles = [
  FIRE_SAFETY_SUPER_ADMIN,
  FIRE_EMERGENCY_CHIEF_FIRE_OFFICER,
  FIRE_AND_EMERGENCY_SERVICES_HOD,
  FIRE_EMERGENCY_SR_MANAGER,
  FIRE_EMERGENCY_MANAGER,
  FIRE_EMERGENCY_SR_EXECUTIVE,
  FIRE_EMERGENCY_ASST_MANAGER,
  ICT_CHIEF_FIRE_OFFICER,
  ICT_SR_MANAGER,
  ICT_MANAGER,
  ICT_SR_EXECUTIVE,
  ICT_ASST_MANAGER,
  PLANNING_CHIEF_FIRE_OFFICER,
  PLANNING_SR_MANAGER,
  PLANNING_MANAGER,
  PLANNING_SR_EXECUTIVE,
  PLANNING_ASST_MANAGER,
  ELECTRICAL_CHIEF_FIRE_OFFICER,
  ELECTRICAL_SR_MANAGER,
  ELECTRICAL_MANAGER,
  ELECTRICAL_SR_EXECUTIVE,
  ELECTRICAL_ASST_MANAGER,
  MECHANICAL_CHIEF_FIRE_OFFICER,
  MECHANICAL_SR_MANAGER,
  MECHANICAL_MANAGER,
  MECHANICAL_SR_EXECUTIVE,
  MECHANICAL_ASST_MANAGER,
];

export const fireSafetyRoles = [FIRE_SAFETY_CONSUMER, ...fireSafetyAdminRoles];

export const allowedRolesForBuildingInformationComment = [
  FIRE_SAFETY_SUPER_ADMIN,
  FIRE_EMERGENCY_SR_MANAGER,
  FIRE_EMERGENCY_CHIEF_FIRE_OFFICER,
];

// Utility Tunnel roles
export const UTILITY_TUNNEL_CONTRACTOR = "Contractor";
export const UTILITY_TUNNEL_EMPLOYEE = "Employee";
export const UTA_CARD_ISSUANCE_SUPER_ADMIN = "UTACardIssuanceSuperAdmin";
export const UTA_CARD_ISSUANCE_INCHARGE = "CardIssuerInCharge";

// Electrical & Instrumentation Engineering
export const ELECTRICAL_AND_INSTRUMENTATION_ENGINEERING_HOD =
  "ElectricalAndInstrumentationEngineeringHOD";
export const ELECTRICAL_AND_INSTRUMENTATION_ENGINEERING_CAPEX_MANAGER =
  "ElectricalAndInstrumentationEngineeringCapExManager";
export const ELECTRICAL_AND_INSTRUMENTATION_ENGINEERING_OPEX_MANAGER =
  "ElectricalAndInstrumentationEngineeringOpexManager";

// Mechanical Engineering
export const MECHANICAL_ENGINEERING_HOD = "MechanicalEngineeringHOD";
export const MECHANICAL_ENGINEERING_CAPEX_MANAGER =
  "MechanicalEngineeringCapExManager";
export const MECHANICAL_ENGINEERING_OPEX_MANAGER =
  "MechanicalEngineeringOpexManager";

// Water Infrastructure
export const WATER_INFRASTRUCTURE_HOD = "WaterInfrastructureHOD";
export const WATER_INFRASTRUCTURE_CAPEX_MANAGER =
  "WaterInfrastructureCapExManager";
export const WATER_INFRASTRUCTURE_OPEX_MANAGER =
  "WaterInfrastructureOpexManager";

// Civil Engineering
export const CIVIL_ENGINEERING_HOD = "CivilEngineeringHOD";
export const CIVIL_ENGINEERING_MANAGER = "CivilEngineeringDepartmentManager";

// IT
export const IT_HOD = "ITHOD";
export const IT_DEPARTMENT_MANAGER = "ITDepartmentManager";

// Fire & Life Safety
export const FIRE_AND_LIFE_SAFETY_HOD = "FireAndLifeSafetyHOD";
export const FIRE_AND_LIFE_SAFETY_DEPARTMENT_MANAGER =
  "FireAndLifeSafetyDepartmentManager";

// Human Resources
export const HUMAN_RESOURCES_HOD = "HumanResourcesHOD";
export const HUMAN_RESOURCES_DEPARTMENT_MANAGER =
  "HumanResourcesDepartmentManager";

// Finance & Accounts
export const FINANCE_AND_ACCOUNTS_HOD = "FinanceAndAccountsHOD";
export const FINANCE_AND_ACCOUNTS_DEPARTMENT_MANAGER =
  "FinanceAndAccountsDepartmentManager";

// IFSC
export const IFSC_HOD = "IFSCHOD";
export const IFSC_DEPARTMENT_MANAGER = "IFSCDepartmentManager";

// Fin Tech
export const FINTECH_DEPARTMENT_HOD = "FinTechDepartmentHOD";
export const FINTECH_DEPARTMENT_MANAGER = "FinTechDepartmentDepartmentManager";

// PA&E
export const PA_AND_E_HOD = "PAAndEHOD";
export const PA_AND_E_DEPARTMENT_MANAGER = "PAAndEDepartmentManager";

// Procurement Contracts & Finance
export const PROCUREMENT_CONTRACTS_AND_FINANCE_HOD =
  "ProcurementContractsAndFinanceHOD";
export const PROCUREMENT_CONTRACTS_AND_FINANCE_DEPARTMENT_MANAGER =
  "ProcurementContractsAndFinanceDepartmentManager";

// Legal & Land
export const LEGAL_AND_LAND_HOD = "LegalAndLandHOD";
export const LEGAL_AND_LAND_DEPARTMENT_MANAGER =
  "LegalAndLandDepartmentManager";

// Business Operations
export const BUSINESS_OPERATIONS_HOD = "BusinessOperationsHOD";
export const BUSINESS_OPERATIONS_DEPARTMENT_MANAGER =
  "BusinessOperationsDepartmentManager";

// Business Development
export const BUSINESS_DEVELOPMENT_HOD = "BusinessDevelopmentHOD";
export const BUSINESS_DEVELOPMENT_DEPARTMENT_MANAGER =
  "BusinessDevelopmentDepartmentManager";

// City Administration
export const CITY_ADMINISTRATION_HOD = "CityAdministrationHOD";
export const CITY_ADMINISTRATION_DEPARTMENT_MANAGER =
  "CityAdministrationDepartmentManager";

// Commercial
export const COMMERCIAL_HOD = "CommercialHOD";
export const COMMERCIAL_DEPARTMENT_MANAGER = "CommercialDepartmentManager";

export const utilityTunnelRoles = [
  UTA_CARD_ISSUANCE_SUPER_ADMIN,
  UTILITY_TUNNEL_CONTRACTOR,
  UTILITY_TUNNEL_EMPLOYEE,
];

export const utilityTunnelAdminRoles = [
  BUSINESS_DEVELOPMENT_HOD,
  BUSINESS_DEVELOPMENT_DEPARTMENT_MANAGER,
  FINTECH_DEPARTMENT_MANAGER,
  FINTECH_DEPARTMENT_HOD,
  UTA_CARD_ISSUANCE_SUPER_ADMIN,
  ELECTRICAL_AND_INSTRUMENTATION_ENGINEERING_HOD,
  ELECTRICAL_AND_INSTRUMENTATION_ENGINEERING_CAPEX_MANAGER,
  ELECTRICAL_AND_INSTRUMENTATION_ENGINEERING_OPEX_MANAGER,
  MECHANICAL_ENGINEERING_HOD,
  MECHANICAL_ENGINEERING_CAPEX_MANAGER,
  MECHANICAL_ENGINEERING_OPEX_MANAGER,
  WATER_INFRASTRUCTURE_HOD,
  WATER_INFRASTRUCTURE_CAPEX_MANAGER,
  WATER_INFRASTRUCTURE_OPEX_MANAGER,
  CIVIL_ENGINEERING_HOD,
  CIVIL_ENGINEERING_MANAGER,
  IT_HOD,
  IT_DEPARTMENT_MANAGER,
  FIRE_AND_LIFE_SAFETY_HOD,
  FIRE_AND_LIFE_SAFETY_DEPARTMENT_MANAGER,
  HUMAN_RESOURCES_HOD,
  HUMAN_RESOURCES_DEPARTMENT_MANAGER,
  FINANCE_AND_ACCOUNTS_HOD,
  FINANCE_AND_ACCOUNTS_DEPARTMENT_MANAGER,
  IFSC_HOD,
  IFSC_DEPARTMENT_MANAGER,
  PA_AND_E_HOD,
  PA_AND_E_DEPARTMENT_MANAGER,
  PROCUREMENT_CONTRACTS_AND_FINANCE_HOD,
  PROCUREMENT_CONTRACTS_AND_FINANCE_DEPARTMENT_MANAGER,
  LEGAL_AND_LAND_HOD,
  LEGAL_AND_LAND_DEPARTMENT_MANAGER,
  BUSINESS_OPERATIONS_HOD,
  BUSINESS_OPERATIONS_DEPARTMENT_MANAGER,
  CITY_ADMINISTRATION_HOD,
  CITY_ADMINISTRATION_DEPARTMENT_MANAGER,
  COMMERCIAL_HOD,
  COMMERCIAL_DEPARTMENT_MANAGER,
  UTA_CARD_ISSUANCE_INCHARGE,
];

export const UTA_HOD_ROLES = [];

export const utilityTunnelConsumerRoles = [
  UTILITY_TUNNEL_CONTRACTOR,
  UTILITY_TUNNEL_EMPLOYEE,
];

export const utilityTunnelAllManagerRoles = [
  UTA_CARD_ISSUANCE_INCHARGE,
  ELECTRICAL_AND_INSTRUMENTATION_ENGINEERING_CAPEX_MANAGER,
  ELECTRICAL_AND_INSTRUMENTATION_ENGINEERING_OPEX_MANAGER,
  MECHANICAL_ENGINEERING_CAPEX_MANAGER,
  MECHANICAL_ENGINEERING_OPEX_MANAGER,
  WATER_INFRASTRUCTURE_CAPEX_MANAGER,
  WATER_INFRASTRUCTURE_OPEX_MANAGER,
  CIVIL_ENGINEERING_MANAGER,
  IT_DEPARTMENT_MANAGER,
  FIRE_AND_LIFE_SAFETY_DEPARTMENT_MANAGER,
  HUMAN_RESOURCES_DEPARTMENT_MANAGER,
  FINANCE_AND_ACCOUNTS_DEPARTMENT_MANAGER,
  IFSC_DEPARTMENT_MANAGER,
  PA_AND_E_DEPARTMENT_MANAGER,
  PROCUREMENT_CONTRACTS_AND_FINANCE_DEPARTMENT_MANAGER,
  LEGAL_AND_LAND_DEPARTMENT_MANAGER,
  BUSINESS_OPERATIONS_DEPARTMENT_MANAGER,
  CITY_ADMINISTRATION_DEPARTMENT_MANAGER,
  COMMERCIAL_DEPARTMENT_MANAGER,
];

export const utilityTunnelAllRoles = [
  ...utilityTunnelConsumerRoles,
  ...utilityTunnelAdminRoles,
];

export const applicantTypes = {
  Individual: 1,
  "Public Ltd.": 2,
  "Pvt. Ltd.": 3,
  Partnership: 4,
  Proprietary: 5,
  "Govt. Dept.": 6,
  "Reg. Trust": 7,
  "Co-operative Society": 8,
  "Public Sector Undertaking(PSU)": 9,
};

export const applicationTypes = {
  "Permanent Connection": 1,
  "Temporary Connection": 2,
  "Name Change/Transfer": 3,
  "Demand Reduction": 4,
  "Demand Extension": 5,
  "Premise Amalgamation": 6,
  "Premise Removal": 7,
  "Shifting of Service": 8,
  "Change of Category": 9,
  "Net Metering": 10,
  "Backup Power": 11,
  "Removal of Connection": 12,
};

export const estimateIssued = "estimate issued";

export const PROCESSED_STATUS = "processed";

export const APPLICATION_PROCESS_COMPLETED_STATUS =
  "application process completed";

export const ESTIMATE_DEPOSITED_STATUS = "estimate deposited";

export const CONNECTION_RELEASED_STATUS = "connection released";

export const applicationStatusTypes = {
  Saved: 1,
  Submitted: 2,
  Reviewed: 3,
  Commented: 4,
  Approved: 5,
  Rejected: 6,
  Processed: 7,
  [estimateIssued]: 8,
  "Estimate deposited": 9,
  "Connection Released": 10,
  "Application Process Completed": 11,
  Refunded: 12,
  Disconnected: 13,
  Expired: 14,
};

export const fireSafetyApplicationStatusTypes = {
  Saved: 1,
  Submitted: 2,
  Reviewed: 3,
  Approved: 4,
  Rejected: 5,
};

export const fireSafetyScheduleStatusTypes = {
  Pending: 1,
  "In Progress": 2,
  Completed: 3,
};

export const applicationApprovalStatusTypes = {
  Approved: 1,
  Rejected: 2,
  Revoked: 3,
};

export const occupancyTypes = {
  Owner: 1,
  "Joint Owner": 2,
  Tenant: 3,
  Lease: 4,
  "Co Lessee": 5,
};

export const premiseAreas = {
  DTA: 1,
  "SEZ-PA": 2,
  "SEZ-NPA": 3,
};

export const identityProofDocuments = {
  "Driving License": 157,
  Passport: 158,
  "Aadhar Card": 159,
  "PAN Card": 160,
  "Electoral Identity Card": 161,
  "Ration Card": 162,
};

export const ownershipDocuments = {
  "Lease deed": 150,
  "Allotment letter": 153,
  "Ownership certificate ": 154,
  "Registered sale deed Copy": 188,
};

export const nameChangeDocuments = {
  "Registered Will/deed": 169,
  "Succession or legal heir certificate": 170,
  "Mutation in municipal/land records": 171,
};

export const allowedStatusForApprove = ["Submitted", "Reviewed", "Commented"];

export const defaultCity = "Gandhinagar";

export const defaultPinCode = "382050";

export const chartColors = [
  "#132659",
  "#5F2566",
  "#220066",
  "#002297",
  "#5102B0",
  "#21B6A8",
  "#A7269F",
  "#035B5B",
  "#2E8BC0",
  "#00A0F3",
  "#4EC3E3",
  "#1DD7ED",
  "#A8004B",
  "#660038",
  "#346F39",
];

export const statusChartColors = ["#2f9e46", "#BF3131", "#37AFE1"];
export const buildingOverallComplianceColor = ["#37AFE1"];
export const buildingNonComplianceBarChartColor = ["#2f9e46", "#BF3131"];
export const lineChartColors = ["#2f9e46", "#F3C623"];
export const complianceLevelBarChartColors = ["#F3C623", "#2f9e46", "#BF3131"];
export const commonInspectionObservationColor = ["#1CD6CE"];

export const masterDataIds = {
  "Applicant Type": 1,
  "Occupancy Type": 2,
  "Premise Type": 3,
  "Premise Area": 4,
  Zone: 5,
  "Application Status": 6,
  "Application Type": 7,
  Block: 8,
  Building: 9,
  "Document Category": 10,
  "Document Type": 11,
  Floor: 12,
  City: 13,
  PinCode: 14,
  "Measurement Type": 15,
  Road: 16,
  Tariff: 17,
  Utility: 18,
  "Utility Application Type Mapping": 19,
  Accessories: 20,
  Charge: 21,
  "Source Of Power": 22,
};

export const locationMasterDataTypes = [
  masterDataIds["City"],
  masterDataIds["PinCode"],
];

export const otpVerificationType = {
  ForgotPassword: 1,
  Verification: 2,
  Login: 3,
  Signature: 4,
};

export const otherMeterId = 0;

export const applicationIdsForChangeMeter = [
  applicationTypes["Demand Extension"],
  applicationTypes["Demand Reduction"],
  applicationTypes["Change of Category"],
  applicationTypes["Premise Amalgamation"],
  applicationTypes["Premise Removal"],
  applicationTypes["Shifting of Service"],
  applicationTypes["Backup Power"],
  applicationTypes["Removal of Connection"],
];

export const premiseNamesForTimeShift = [
  "commercial",
  "hostel",
  "hospital",
  "hotels/restaurants",
  "industrial",
];

export const dateFormats = [
  "YYYY-MM-DDTHH:mm:ss",
  "YYYY-MM-DDTHH:mm:ss.SSSSSS",
  "YYYY-MM-DDTHH:mm:ss+hh:mm",
  "YYYY-MM-DDTHH:mm:ss.SSSSSS+hh:mm",
];

export const regexForName =
  /^[()@./#&$+a-zA-Z0-9]([()@./#&$+a-zA-z0-9 _-]*[()a-zA-Z0-9@./#$&+])?$/;

export const SINGLE_PHASE = 1;
export const THREE_PHASE = 2;

export const SECURITY_DEPOSIT_KEY = "securityDeposit";

export const tentionOptions = [
  { value: "LT", label: "LT" },
  { value: "HT", label: "HT" },
];

export const confirmationOptions = [
  { label: "Yes", value: 1 },
  { label: "No", value: 0 },
];

export const fireSafetyNotificationType = {
  1: "BuildingInformation",
  2: "BuildingSchedule",
  3: "Observation",
  4: "DashboardSchedule",
};

export const htLoadOptions = [{ value: 2, label: "Three Phase" }];

export const maxLtContractDemandLoad = 150;
export const minHtContractDemandLoad = 151;

export const singlePhaseOptions = [{ value: 240, label: "240 V" }];

export const meterReadingKeys = [
  "instantaneousVoltageV",
  "instantaneousCurrentA",
  "instantaneousActivePowerkW",
  "activeImportEnergy",
  "activeExportEnergy",
  "currentImportMD",
  "currentExportMD",
  "rPhaseVoltage",
  "yPhaseVoltage",
  "bPhaseVoltage",
  "rPhaseCurrent",
  "yPhaseCurrent",
  "bPhaseCurrent",
  "neutralCurrent",
  "instActivePower",
  "instApparentPower",
  "instantaneousPF",
  "frequency",
  "apparentImportEnergy",
  "apparentExportEnergy",
  "reactiveEnergyQ1",
  "reactiveEnergyQ2",
  "reactiveEnergyQ3",
  "reactiveEnergyQ4",
  "currentApparentImportMD",
  "currentApparentExportMD",
  "averagePowerFactor",
  "phaseSequence",
  "currentActiveImportPeakHourEnergyMWhTOD1",
  "currentActiveImportPeakHourEnergyMWhTOD5",
  "currentActiveExportPeakHourEnergyMWh",
  "currentActiveImportNightHourEnergyMWh",
  "currentActiveExportNightHourEnergyMWh",
  "currentActiveImportRestHourEnergyMWh",
  "currentActiveExportRestHourEnergyMWh",
  "hist1ActiveImportEnergy",
  "hist1ActiveExportEnergy",
  "hist2ActiveImportEnergy",
  "hist2ActiveExportEnergy",
  "hist1ActiveImportMD",
  "hist1ActiveExportMD",
  "hist2ActiveImportMD",
  "hist2ActiveExportMD",
  "hist1ApparentImportMD",
  "hist1ApparentExportMD",
  "hist2ApparentImportMD",
  "hist2ApparentExportMD",
  "currentDefrauded",
  "cumulativeTamperCount",
];

export const meterKeys = [
  "make",
  "labNo",
  "phaseOrWire",
  "voltageRating",
  "currentRating",
  "meterCTR",
  "meterPTR",
  "pulseOrkwH",
  "class",
  "dialMF",
];

export const otherUtilityMeterReadingUnits = {
  2: "TR-Hr",
  3: "KL",
  4: "KL",
  5: "Sq. Ft",
};

export const maxContractDemandForNonDomesticPremise = 9999;
export const maxContractDemandForDomesticPremise = 999;
export const maxWaterDemand = 99999999;

export const fireSafetyBasementCollection = [
  "Basement",
  "Upper Basement",
  "Lower Basement",
  "Service Basement",
  "B1",
  "B2",
  "B3",
];

export const fireSafetyGroundFloor = ["Ground Floor"];

export const fireSafetyFloorCollection = [
  "1st Floor",
  "2nd Floor",
  "3rd Floor",
  "4th Floor",
  "5th Floor",
  "6th Floor",
  "7th Floor",
  "8th Floor",
  "9th Floor",
  "10th Floor",
  "11th Floor",
  "12th Floor",
  "13th Floor",
  "14th Floor",
  "15th Floor",
  "16th Floor",
  "17th Floor",
  "18th Floor",
  "19th Floor",
  "20th Floor",
  "21st Floor",
  "22nd Floor",
  "23rd Floor",
  "24th Floor",
  "25th Floor",
  "26th Floor",
  "27th Floor",
  "28th Floor",
  "29th Floor",
  "30th Floor",
  "31st Floor",
  "32nd Floor",
  "33rd Floor",
  "34th Floor",
  "35th Floor",
  "36th Floor",
  "37th Floor",
  "38th Floor",
  "39th Floor",
  "40th Floor",
];
